import { useState } from "react";
import { X, Play } from "lucide-react";

const IMAGES = [
  "/media/m1.webp",
  "/media/m2.webp",
  "/media/m4.webp",
  "/media/m3.webp",
  "/media/m5.webp",
  "/media/m6.webp",
  "/media/m7.webp",
];

export default function MediaGallery() {
  const [lightbox, setLightbox] = useState(null);

  return (
    <>
      <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 [column-fill:_balance]" data-testid="media-grid">
        {/* Featured video */}
        <div className="mb-4 break-inside-avoid rounded-2xl overflow-hidden border border-white/10 bg-black relative">
          <video
            controls
            playsInline
            preload="metadata"
            poster="/media/clip1-poster.jpg"
            className="w-full h-auto block"
            data-testid="media-video"
          >
            <source src="/media/clip1.mp4" type="video/mp4" />
          </video>
          <div className="absolute top-4 left-4 pointer-events-none">
            <span className="font-mono text-[10px] tracking-[0.2em] px-2.5 py-1 rounded-full bg-black/50 text-white border border-white/20 flex items-center gap-1">
              <Play size={11} /> VIDEO
            </span>
          </div>
        </div>

        {IMAGES.map((src, i) => (
          <button
            key={src}
            onClick={() => setLightbox(src)}
            className="mb-4 w-full break-inside-avoid group relative rounded-2xl overflow-hidden border border-white/10 block"
            data-testid={`media-image-${i}`}
          >
            <img
              src={src}
              alt={`ADJ intervento ${i + 1}`}
              loading="lazy"
              className="w-full h-auto block group-hover:scale-[1.03] transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors" />
          </button>
        ))}
      </div>

      {lightbox && (
        <div
          className="fixed inset-0 z-[110] bg-black/90 backdrop-blur-sm flex items-center justify-center p-4 animate-float-up"
          onClick={() => setLightbox(null)}
          data-testid="media-lightbox"
        >
          <button className="absolute top-5 right-5 glass rounded-full h-11 w-11 flex items-center justify-center text-white hover:border-[#F5842B]/60 transition-colors" data-testid="media-lightbox-close">
            <X size={20} />
          </button>
          <img src={lightbox} alt="ADJ media" className="max-w-full max-h-[88vh] rounded-2xl border border-white/15" onClick={(e) => e.stopPropagation()} />
        </div>
      )}
    </>
  );
}
